import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { EditableComponent, CreatedComponent } from '../../common/model/types.tsx';
import componentHandler from '../../common/services/component-handler.tsx';
import { create as createRequest, type CreateRequestPayload } from '../rest/create.tsx';
import { getBaseUrl } from './index.tsx';
import { transformComponent } from './transform.tsx';

export const create = (
	projectId: number,
	projectKey: ProjectKey,
	component: EditableComponent,
): Promise<CreatedComponent> => {
	const { name, description, lead, defaultAssignee } = component;
	const componentLeadField = lead && { leadAccountId: lead.accountId };

	const payload: CreateRequestPayload = {
		name,
		description,
		assigneeType: defaultAssignee,
		project: projectKey,
		projectId,
		...componentLeadField,
	};

	return componentHandler(createRequest(getBaseUrl(), payload), transformComponent, projectKey);
};
